var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.37 347.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "299.37 242.91 266.25 242.91 203.41 133.54 203.24 133.82 203.19 133.73 186.62 104.88 186.61 104.88 186.56 104.78 169.99 75.95 159.52 57.72 50.68 242.91 71.85 242.91 55.02 271.55 24.04 271.59 23.85 271.91 0 271.91 159.8 0 186.9 47.17 203.47 76 203.52 76.1 203.53 76.11 220.1 104.95 299.37 242.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "357.44 271.91 357.86 271.19 349.33 271.2 315.97 271.24 315.64 271.24 282.55 271.28 166.77 271.41 166.76 271.43 122.34 271.48 139.13 242.91 354.26 242.91 247.86 57.72 237.06 76.1 220.47 47.28 247.67 1 247.55 1 248.14 0 404.37 271.91 357.44 271.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "359.92 347.73 43.89 347.73 71.63 300.53 88.45 271.91 88.68 271.52 105.49 242.91 150.84 165.74 150.85 165.74 186.62 104.88 203.19 133.73 139.02 242.91 139.13 242.91 122.34 271.48 122.09 271.91 105.29 300.49 94.57 318.73 309.81 318.73 299.19 300.25 332.62 300.21 359.92 347.73"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84c2e9dcea5aba51731e8fe9394b8c1a.svg";
export { ForwardRef as ReactComponent };